module.exports = __webpack_public_path__ + "static/about-us-15-382292a59a515de75d583f05cc9b6bd9.jpg";